module.exports = __webpack_public_path__ + "38502046f51bb355d3ac8835bfcff995.svg";